export { default } from './CompletedContestCard';
